import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import Disclaimer from "./Disclaimer";
import RouteCard from "./RouteCard";
import BottomNav from './BottomNav';
import ShareModal from './ShareModal';
import InfoModal from './InfoModal';

const CityRoutes = () => {
  // Access the locationId parameter from the URL
  const { locationId } = useParams();

  const [location, setLocation] = useState([]);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [disclaimerModal, setDisclaimerModal] = useState(false);
  useEffect(() => {
    let isMounted = true;
    setLoader(true);
    const fetchLocation = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_LOCATIONS + "/" + locationId);
        if (isMounted) {
          setLocation(response.data.data);
          console.log(response.data.data);
        }
      } catch (err) {
        if (isMounted) {
          setError(err.message || "Something went wrong");
        }
        console.error("Error:", err);
      }
    };

    fetchLocation();

    return () => {
      isMounted = false; // Cleanup: prevent setting state if component is unmounted
    };
  }, []);

  // If the location doesn't exist, return a not found message
  if (!location) {
    return <h1>Location Not Found</h1>;
  }

  return (
    <>
      <Disclaimer disclaimerModal={disclaimerModal} setDisclaimerModal={setDisclaimerModal} />
      <div id="routes-list">
        {location.length && (
          <>
            <h2 style={{ color: "#fff", fontSize: 26, textAlign: "center",display:'flex',alignItems:'center',justifyContent:'center',gap:20 }}>
             
                      <svg style={{maxWidth:25,height:'auto'}}  width="28" height="25" viewBox="0 0 38 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 16.19V13.161C7.531 13.161 17.082 1.894 17.269 0L20.298 0.0199995C20.298 3.752 9.026 16.19 0 16.19Z" fill="#FFFFFFBF"/>
            <path d="M37.5658 16.19C28.5398 16.19 17.2678 3.75202 17.2678 0.0200195H20.2978C20.4838 1.89402 30.0348 13.161 37.5658 13.161V16.19Z" fill="#FFFFFFBF"/>
            <path d="M17.9318 3.45204L4.72384 14.031C4.40284 14.284 4.21484 14.671 4.21484 15.081V31.101C4.21484 32.298 5.18684 33.268 6.38384 33.268H12.4058C12.7618 33.268 13.1018 33.127 13.3528 32.876C13.6028 32.625 13.7448 32.285 13.7448 31.93V22.146C13.7448 21.409 14.3428 20.808 15.0828 20.808H22.4828C22.8388 20.808 23.1778 20.949 23.4288 21.2C23.6798 21.451 23.8208 21.791 23.8208 22.146V31.922C23.8208 32.277 23.9618 32.617 24.2128 32.868C24.4638 33.119 24.8038 33.26 25.1598 33.26H31.1818C32.3788 33.26 33.3508 32.29 33.3508 31.093V15.081C33.3488 14.668 33.1548 14.281 32.8288 14.03L19.6208 3.45104C19.1288 3.05204 18.4238 3.05204 17.9318 3.45104V3.45204Z" fill="#FFFFFFBF"/>
        </svg>
              <span> Locations</span>
            </h2>
            <p style={{ fontSize: 18, color: "#FFFFFFBF", textAlign: "center", marginBottom: 42 }}>There are {location.length} guided tours to choose from. Select one below to get started.</p>
          </>
        )}

        {location && location.map((location) => <RouteCard status={location.status} key={location.id} text={location.text} stops={location.stops} title={location.title} image={location.image} distance={location.distance} url={`/city-route/${location.id}`} />)}
      </div>

      {!disclaimerModal && <BottomNav
        activeIcon={shareModal ? 'share' : infoModal ? 'info' : 'home'}
        onInfoClick={() => setInfoModal(true)}
        onShareClick={() => setShareModal(true)}
        onClose={() => { setShareModal(false); setInfoModal(false); }}
      />}
      <ShareModal shareModal={shareModal} setShareModal={setShareModal} />
      <InfoModal infoModal={infoModal} setInfoModal={setInfoModal} />
    </>
  );
};

export default CityRoutes;
